module.exports = __webpack_public_path__ + "static/img/chahua.cca34a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chahua.png
// module id = QzbA
// module chunks = 102